import { z } from 'zod';
import { FINANCIAL_PRODUCT } from '../constants';
import {
  applicantWithIdentification,
  applicantWithNoMedicareIdentification,
  applicantWithPhotoIdentification,
  generateSchema,
} from '../shared';
import { ApplicationStep } from '../types';
import { baseApplicationStep } from './baseApplication';

const defaultSchema = {
  applicant: applicantWithIdentification,
};

const actSlipSchema = {
  applicant: applicantWithPhotoIdentification.and(
    z
      .object({
        identification: z.object({
          documentIds: z.array(z.string().optional()).optional(),
          isSkipDocuments: z.boolean().optional(),
        }),
      })
      .refine(
        val => {
          if (
            (!val.identification.documentIds || val.identification.documentIds?.length === 0) &&
            !val.identification.isSkipDocuments
          ) {
            return false;
          }
          return true;
        },
        { message: 'Concession Card document is required' },
      ),
  ),
};

const actSHSAndTasSchema = {
  applicant: applicantWithPhotoIdentification,
};

const flexIdentificationSchema = {
  applicant: applicantWithNoMedicareIdentification,
};

const electrify2515Schema = {
  applicant: applicantWithIdentification.and(
    z
      .object({
        isConcessionCardHolder: z.boolean(),
        identification: z.object({
          documentIds: z.array(z.string().optional()).optional(),
          isSkipDocuments: z.boolean().optional(),
        }),
      })
      .refine(
        val => {
          if (
            val.isConcessionCardHolder === true &&
            (!val.identification.documentIds || val.identification.documentIds?.length === 0) &&
            !val.identification.isSkipDocuments
          ) {
            return false;
          }
          return true;
        },
        { message: 'Concession Card document is required' },
      ),
  ),
};

const customSchemas = {
  [FINANCIAL_PRODUCT.ACT_SLIP]: actSlipSchema,
  [FINANCIAL_PRODUCT.FLEX]: flexIdentificationSchema,
  [FINANCIAL_PRODUCT.ELECTRIFY_2515]: electrify2515Schema,
  [FINANCIAL_PRODUCT.ACT_SHS]: actSHSAndTasSchema,
  [FINANCIAL_PRODUCT.TAS_ESLS]: actSHSAndTasSchema,
};

export const identificationSchema = generateSchema<typeof customSchemas, typeof defaultSchema>({
  customSchemas,
  defaultSchema,
});

export const updateApplicationIdentificationSchema = identificationSchema.and(baseApplicationStep).and(
  z.object({
    step: z.literal(ApplicationStep.Identification),
  }),
);
